import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';
import numeral from 'numeral';

import { Modal } from 'synfrastructure';

import SessionRequestModal from '../../../common/components/session-requests/SessionRequestModal';
import Loading from '../../../common/components/Loading';
import Icon from '../../../common/icons/Icon';
import { getTathataFollowUpData } from '../../redux/actions';
import { createSession } from './redux/actions';
import { pushToast } from '../../../redux/actions';
import getDecodedToken from '../../../common/auth/utils/getDecodedToken';
import { reportTrainingPurchase, sendIntercomEvent } from '../../../common/events';

class InPersonFollowUp extends Component {
  state = {
    modalVisible: false,
    bryan: false,
  };

  componentDidMount = () => {
    if (!this.props.tathataFollowUpData.get('loaded')) {
      this.props.dispatch(getTathataFollowUpData());
    }
    sendIntercomEvent('viewed_in_person_follow_up');
  };

  handleToggleModal = isBryan => {
    !this.state.modalVisible && sendIntercomEvent('viewed_in_person_follow_up_purchase_modal');
    this.setState(state => {
      return {
        modalVisible: !state.modalVisible,
        bryan: !!isBryan,
      };
    });
  };

  handleSubmit = values => {
    const { dispatch } = this.props;
    const submitValues = cloneDeep(values);
    submitValues.bryan = !!this.state.bryan;

    submitValues.requestedDates = submitValues.requestedDates.map(obj => {
      let hour = parseInt(obj.time.substr(0, 2), 10);

      if (obj.time.substr(0, 2) === '12') {
        hour = 0;
      }

      if (obj.time.substr(5, 2) === 'PM') {
        hour += 12;
      }

      return moment(obj.date)
        .tz('America/Phoenix')
        .hour(hour)
        .minute(parseInt(obj.time.substr(3, 2), 10))
        .format();
    });

    return dispatch(createSession(getDecodedToken().sub, submitValues)).then(action => {
      if (!action.response.ok) {
        dispatch(
          pushToast({
            message: 'There was a problem while submitting your request.',
            status: 'error',
          })
        );
      } else {
        reportTrainingPurchase({
          gaEventLabel: 'In-Person',
        });
      }
    });
  };

  render = () => {
    const { modalVisible } = this.state;
    const { session, tathataFollowUpData } = this.props;

    if (!tathataFollowUpData.get('loaded')) {
      return <Loading />;
    }

    let price = tathataFollowUpData.getIn(['data', 'price']);
    let formattedPrice = price === 0
      ? 'FREE'
      : numeral(price / 100).format('$0,0');
    let bryanPrice = tathataFollowUpData.getIn(['data', 'bryanPrice']);
    let formattedBryanPrice = bryanPrice === 0
      ? 'FREE'
      : numeral(bryanPrice / 100).format('$0,0');

    let whichPrice = !!this.state.bryan ? bryanPrice : price;

    return (
      <div className="follow-up__wrapper">
        {modalVisible && (
          <Modal
            isVisible
            onClose={this.handleToggleModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <SessionRequestModal
              availability={tathataFollowUpData.getIn(['data', 'availability'])}
              name="Tathata"
              onCancel={this.handleToggleModal}
              price={whichPrice}
              onSubmit={this.handleSubmit}
              session={session}
              timeZoneId="MST"
              type="in-person"
            />
          </Modal>
        )}
        <div
          className="gs-page__hero__wrapper"
          style={{ backgroundImage: 'url("https://d27vybgvtr1dba.cloudfront.net/online-follow-ups/hero.jpg")' }}
        >
          <div className="container">
            <div className="gs-page__hero">
              <Link className="gs__back" to={`/subscription/coaching`}>
                <span className="button__back-button">
                  <Icon icon="BackArrow" />Back to Additional Coaching
                </span>
              </Link>
              <div className="header-container">
                <h1>Tathata In-Person Follow-Up</h1>

                <div className="button-holder">
                  <button type="button" className="button button--price" onClick={() => this.handleToggleModal(false)}>
                    <span>Request Follow-Up</span>
                    <i>{formattedPrice}</i>
                  </button>

                  <button type="button" className="button button--price" onClick={() => this.handleToggleModal(true)}>
                    <span>Request Bryan</span>
                    <i>{formattedBryanPrice}</i>
                  </button>
                </div>
              </div>
              <p>
                As you move through the 60-Day Training Program and supporting training courses, Tathata Golf is ready
                to help assess correct and enhance your movements live at the Tathata Training Center. Use an In-Person
                Follow-Up to enhance your learning and understanding of the curriculum while increasing your movement
                speed & accuracy ultimately leading to better golf.
              </p>
            </div>
          </div>
        </div>
        <div className="ip-ol-follow-up--info__wrapper">
          <div className="ip-ol-follow-up--info">
            <div className="ip-ol-follow-up--info__img">
              <img src="https://d27vybgvtr1dba.cloudfront.net/swing-submittals/details.jpg" alt="Online Follow-Ups" />
            </div>
            <div className="ip-ol-follow-up--info__details-container">
              <div className="ip-ol-follow-up--info__details">
                <h2>In-Person Follow-Up</h2>
                <div className="bullets">
                  <div>
                    <span className="bull">&bull;</span>
                    Live support from Tathata staff
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Experience & utilize the Tathata Training Center
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Flexible booking system
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Increase the speed & accuracy of your movements
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Enjoy help with all Tathata Training Courses
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Personalized assessment & enhancement
                  </div>
                  <div>
                    <span className="bull">&bull;</span>
                    Post Follow-Up training plan
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state, props) => {
  return {
    session: state.subscription.inPersonFollowUp.session,
    tathataFollowUpData: state.subscription.tathataFollowUpData,
  };
};

export default connect(mapStateToProps)(InPersonFollowUp);



// WEBPACK FOOTER //
// ./src/subscription/coaching/in-person-follow-up/InPersonFollowUp.js